<template>
  <div class="product-links-view">
    <h5 class="text-semibold mb-5">Links de divulgação</h5>
    <div class="product-links-card">
      <div v-if="product && product.charge_type === 'recurrent'">
        <action-dispatcher
          action="plan/get"
          :parameters="{ product_id: $route.params.id, limit: 100 }"
        >
          <div class="d-flex flex-column gap-4">
            <snow-links-inputs
              v-for="(plan, i) in plans"
              :key="`plan-link-${i}`"
              :product="product"
              :label="plan.name"
              :custom_url="plan.url"
            />
          </div>
        </action-dispatcher>
      </div>

      <div v-else-if="product && product.type_product === 'onsite_event'">
        <div class="text-center my-9" v-if="loading">
          <b-spinner variant="primary" />
        </div>
        <template v-else>
          <action-dispatcher
            action="events/getLots"
            :parameters="{ product_id: $route.params.id, limit: 100 }"
          >
            <div class="d-flex flex-column gap-4">
              <snow-links-inputs
                v-for="(link, i) in eventLinks"
                :key="`event-link-${i}`"
                :product="product"
                :label="link.label"
                :custom_url="link.url"
              />
              <div
                v-if="eventLinks.length == 0"
                class="d-flex justify-content-center mt-7"
              >
                <div class="row justify-content-center">
                  <div
                    class="col-lg-6 d-flex flex-column align-items-center text-center gap-4"
                  >
                    <img src="@/assets/images/no-content.svg" />
                    <small>
                      Você ainda não tem ingressos cadastrados, clique no botão
                      abaixo e cadastre o primeiro
                    </small>
                    <snow-button
                      variant="gray"
                      text="cadastrar"
                      icon="ph ph-plus"
                      @click="
                        $router.push({
                          name: 'event-new-lot',
                          params: { id: $route.params.id }
                        })
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </action-dispatcher>
        </template>
      </div>

      <div v-else-if="product">
        <snow-links-inputs :product="product" label="Oferta Principal" />
        <action-dispatcher
          action="offer/get"
          :parameters="{ product_id: $route.params.id, limit: 100 }"
        >
          <div class="d-flex flex-column gap-4">
            <h5 class="text-semibold my-4">Links de ofertas</h5>
            <snow-links-inputs
              v-for="(link, i) in offers"
              :key="`offer-link-${i}`"
              :product="product"
              :label="link.name"
              :custom_url="link.url"
            />
          </div>
        </action-dispatcher>
      </div>
    </div>
  </div>
</template>

<script>
import ProductActionsMixin from "@/mixins/productActions.js";
import { mapState } from "vuex";

export default {
  mixins: [ProductActionsMixin],
  data() {
    let offer = "";
    if (this.$route.query.offer && this.$route.query.offer !== "padrao") {
      offer = this.$route.query.offer;
    }
    let plan = "";
    if (this.$route.query.plan && this.$route.query.plan !== "padrao") {
      plan = this.$route.query.plan;
    }
    return {
      loading: false,
      filters: {
        plan,
        offer,
        group: ""
      }
    };
  },
  computed: {
    ...mapState("membersGroups", ["groupsFilter"]),
    ...mapState("product", ["product"]),
    ...mapState("plan", ["plans"]),
    ...mapState("offer", ["offers"]),
    ...mapState("events", ["lots"]),
    plan() {
      return this.plans.find(plan => plan.id === this.filters.plan);
    },
    offer() {
      return this.offers.find(offer => offer.id === this.filters.offer);
    },
    group() {
      return this.groupsFilter.find(group => group.id === this.filters.group);
    },
    eventLinks() {
      return this.lots.map(t => ({ ...t, label: t.name }));
    }
  },
  watch: {
    "filters.offer"() {
      this.filters.group = null;
    },
    "filters.plan"() {
      this.filters.group = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.product-links-view {
  .product-links-card {
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: var(--bg-2);
    padding: 24px;
    border-radius: 16px;
  }
}
</style>
